// ── Switch between local and live by uncommenting one line ──

//export const baseUrl = 'https://clubnet.app/demo_nmm/Admin/Member/';
// export const baseUrl = 'http://localhost:8086/Member/';
export const baseUrl = 'https://clubnet.app/GFG_/Backend/Member/';
// export const baseUrl = 'https://clubnet.app/dev.nmm.gfg/app/Member/';
// ── Other live URLs (uncomment as needed) ──
//export const baseUrl = 'https://clubnet.app/nmmSetups/EFFN/Backend/Member/';
// export const baseUrl = 'https://clubnet.app/GFG_/Backend/Member/';

// ── Backend root URL (used for Google OAuth redirect) ──
// Strips /Admin/Member/ or /Member/ to get the server root + BASE_URI
// Live:  https://clubnet.app/demo_nmm/Admin/Member/ → https://clubnet.app/demo_nmm
// Local: http://localhost:8086/Member/              → http://localhost:8086
export const backendUrl = baseUrl
  .replace(/\/Member\/$/, '')
  .replace(/\/Member$/, '');  

  
 
  